module.exports = __webpack_public_path__ + "static/media/bgcLogin.69f23dc3.png";